const bankDepositImportModelEnum = {
  PROSEGUR: 'Prosegur',
  ECHOPE: 'Echope',
}

const checkingAccountDomains = {
  data() {
    return {
      bankDepositImportModelEnum,
    }
  },

  computed: {
    bankDepositImportTypeLabel() {
      return {
        [bankDepositImportModelEnum.ECHOPE]: this.$t('echope'),
        [bankDepositImportModelEnum.PROSEGUR]: this.$t('Prosegur'),
      }
    },
  },
  methods: {
    checkingAccountFilterTypeOptions() {
      return [
        { value: 'SafeBox', label: this.$t('Cofre') },
        { value: 'Exchange', label: this.$t('Troco') },
        { value: 'Main', label: this.$t('Conta principal') },
        { value: 'Internal', label: this.$t('Conta interna (desconsidera cofre e troco)') },
      ]
    },

    bankDepositImportTypeOptions() {
      const { ECHOPE, PROSEGUR } = bankDepositImportModelEnum
      return [
        { value: ECHOPE, label: this.bankDepositImportTypeLabel[ECHOPE] },
        { value: PROSEGUR, label: this.bankDepositImportTypeLabel[PROSEGUR] },
      ]
    },
  },
}

export default checkingAccountDomains
